/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Chip } from '@coursera/cds-core';

export type OptionPillProps = {
  label: string;
  selected: boolean;
  onClick: () => void;
  icon?: React.ReactElement;
  iconSize?: 'small' | 'medium';
};

const styles = {
  customChip: (iconSize: 'small' | 'medium') => css`
    &.cds-Chip-root {
      padding: var(--cds-spacing-100) var(--cds-spacing-200);
      border-color: var(--cds-color-grey-50);
      font-weight: 400;

      .cds-Chip-startIcon {
        img,
        svg {
          border-radius: 50%;
          width: ${iconSize === 'small' ? 'var(--cds-spacing-200)' : '28px'};
          height: ${iconSize === 'small' ? 'var(--cds-spacing-200)' : '28px'};
        }

        ${iconSize === 'medium' && `margin-right: var(--cds-spacing-100);`}
      }
    }

    &.cds-Chip-root:hover {
      color: var(--cds-color-grey-900);
      background-color: var(--cds-color-interactive-background-primary-hover-weak);
      border-color: var(--cds-color-blue-700);
    }

    &.cds-Chip-selected {
      color: var(--cds-color-blue-700);
      background-color: var(--cds-color-white-0);
      border-color: var(--cds-color-blue-700);
    }
  `,
};

/**
 * CDS Chip component with custom styles. This should be used in a CDS ChipGroup.
 */
const OptionPill = ({ label, selected, onClick, icon, iconSize = 'medium' }: OptionPillProps) => {
  return (
    <Chip icon={icon} onClick={onClick} variant="select" selected={selected} css={styles.customChip(iconSize)}>
      {label}
    </Chip>
  );
};

export default OptionPill;
